import type * as SentryReactType from "@sentry/react";
import type * as SentryTracingType from "@sentry/tracing";

/**
 * 前端日志追踪
 */
export const Sentry = window["_SE_SentryReact"] as typeof SentryReactType;
export const SentryTracing = window["_SE_SentryTracing"] as typeof SentryTracingType;
